import AWS from 'aws-sdk'

// Validate AWS credentials
const validateAWSCredentials = () => {
  const accessKeyId = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
  const secretAccessKey = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;
  const region = process.env.REACT_APP_AWS_REGION;
  const bucketName = process.env.REACT_APP_AWS_S3_BUCKET_NAME || 'zynthimages';

  if (!accessKeyId || !secretAccessKey) {
    console.error('❌ AWS credentials missing!');
    console.error('REACT_APP_AWS_ACCESS_KEY_ID:', accessKeyId ? '✓ Set' : '✗ Missing');
    console.error('REACT_APP_AWS_SECRET_ACCESS_KEY:', secretAccessKey ? '✓ Set' : '✗ Missing');
    console.error('REACT_APP_AWS_REGION:', region || 'Using default: us-east-1');
    console.error('REACT_APP_AWS_S3_BUCKET_NAME:', bucketName || 'Using default: zynthimage');
    console.error('\n⚠️  Please restart the development server to load .env variables!');
    throw new Error('AWS credentials are not configured. Please check your .env file and restart the server.');
  }

  console.log('✅ AWS credentials loaded successfully');
  return { accessKeyId, secretAccessKey, region, bucketName };
};

// Get and validate credentials
const credentials = validateAWSCredentials();

// Set up AWS S3 credentials
const s3 = new AWS.S3({
  accessKeyId: credentials.accessKeyId,
  secretAccessKey: credentials.secretAccessKey,
  region: credentials.region || 'us-east-1',
});

// Define the interface for the file parameter
interface UploadFile {
  name: string
  type: string
  body: Blob | File // Define file body type
}

// Function to upload a file to S3 bucket
const uploadFileToS3 = async (file: UploadFile): Promise<string> => {
  const fileName = file.name // Original file name
  const uniqueId = Date.now() // Generate a unique ID (timestamp is better)
  const key = `uploads/${uniqueId}_${fileName}` // Set the key with a prefix 'uploads/'

  const params: AWS.S3.PutObjectRequest = {
    Bucket: credentials.bucketName || 'zynthimage',
    Key: key,
    Body: file.body, // File content
    ContentType: file.type, // File type
  }

  try {
    // Use AWS SDK's managed upload with concurrency options
    const upload = s3.upload(params, {
      partSize: 5 * 1024 * 1024, // 5MB part size
      queueSize: 5, // Concurrency level
    })

    // Progress monitoring (optional)
    upload.on('httpUploadProgress', (progress) => {
      console.log(`Uploaded: ${(progress.loaded / progress.total) * 100}%`)
    })

    const data = await upload.promise()
    console.log('PDF Link: ', data.Location)
    return data.Location // Return the public URL of the uploaded file
  } catch (error) {
    console.error('Error uploading file:', error)
    throw error
  }
}

export default uploadFileToS3
